<template>
  <div id="footer" class="container-fluid">
<!--    <div class="logo">-->
<!--      <img src="@/assets/img/logo_white.png" alt="logo图">-->
<!--    </div>-->
<!--    <p class="title">公司企业网站模板</p>-->
<!--    <p class="address_tel_fax">-->
<!--      <span>地址：公司地址</span>-->
<!--      <span>Tel：888-888-888</span>-->
<!--    </p>-->
<!--    <p class="email_wx">-->
<!--      <span>邮箱：xxx@163.com</span>-->
<!--      <span>微信号：xxx</span>-->
<!--    </p>-->
    <p class="copy">Copyright &copy; 2022 - {{ new Date().getFullYear() }} 百君科技有限公司
      <a class="content2" href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2024211963号</a>
      <img class="icon" src="@/assets/img/footer_icon01.png" alt="小图标">
      <a class="content" href="https://beian.mps.gov.cn/#/query/webSearch?recordcode=44040302000453" target="_blank">粤公网安备44040302000453号</a></p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
.content {
  /*padding: 10px;*/
  margin-left: 2px; /* 设置左边距为 20px */
  color: #ffffff; /* 设置文本颜色为红色 */
}
.content2 {
  /*padding: 10px;*/
  margin-left: 10px; /* 设置左边距为 20px */
  color: #ffffff; /* 设置文本颜色为红色 */
}
.icon {
  margin-left: 10px; /* 设置左边距为 20px */
  display: inline-block;
  vertical-align: middle; /* 设置垂直对齐方式，可以根据需要调整 */
  /*width: 17px; !* 设置图标的宽度 *!*/
  /*height: 18px; !* 设置图标的高度 *!*/
  padding-bottom: 4px;
}

#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 45px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 15px;
  margin: 20px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue